import apiCall from "..";
// Get Dashboard Menu Items
export function getMenu() {
	return apiCall.get("/menu");
}
